import type { Header } from "@tanstack/react-table";

// one stable component calls the column's header function, so a page that
// rebuilds its columns (and with them that function) updates the header in
// place; rendered as the function itself, each rebuild was a new component
// type and remounted whatever the header held, like an open filter. a header
// given as a component (one that uses hooks) is called here too, so a column
// should keep the same header function rather than swap it for another
export function TableHeaderContent<T>({
  header,
}: Readonly<{ header: Header<T, unknown> }>) {
  const render = header.column.columnDef.header;
  return typeof render === "function" ? render(header.getContext()) : render;
}
